import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';
import { XCircle } from 'lucide-react';
import { Link } from 'react-router';

export const EmailVerificationWithoutTokenPage = () => {
  useLocale();

  return (
    <div className="w-screen max-w-lg px-4">
      <div className="flex w-full items-start">
        <div className="me-4 mt-1 hidden md:block">
          <XCircle className="h-10 w-10 text-destructive" strokeWidth={2} />
        </div>
        <div>
          <h2 className="font-bold text-2xl md:text-4xl">
            {t('auth.uhOhLooksLikeYouReMissingAToken')}{' '}
          </h2>
          <p className="mt-4 text-muted-foreground">
            {t('auth.itSeemsThatThereIsNoTokenProvidedIf')}{' '}
          </p>
          <Button asChild className="mt-4">
            <Link to="/">{t('auth.goBackHome')}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
